import React from 'react';

export default ({ marginTop, children }) => {
  const style = {
    minHeight: '36px'
  };

  if (marginTop) {
    style.marginTop = '24px';
  }

  return <div style={style}>{children}</div>;
};



// WEBPACK FOOTER //
// ./components/SecurityBoxControls.jsx